import React, { useState } from "react";
import panipuri from "../../assets/panipuri.jpg";
import vadapav from "../../assets/vadapav.jpg";
import pavbhaji from "../../assets/pavbhaji.jpg";
import chole from "../../assets/chole.jpg";
import dabeli from "../../assets/dabeli.jpg";
import alootikki from "../../assets/alootikki.jpg";
import kathiroll from "../../assets/kathiroll.jpg";
import momos from "../../assets/momos.jpg";
import samosa from "../../assets/samosa.jpg";
import pohajalebi from "../../assets/pohajalebi.jpg";
import kachori from "../../assets/kachori.jpg";
import misalpav from "../../assets/misalpav.jpg";
import seviya from "../../assets/seviya.jpg";
import bhelpuri from "../../assets/bhelpuri.jpg";
import dhokla from "../../assets/dhokla.jpg";
import idli from "../../assets/idli.jpg";
import meduvada from "../../assets/meduvada.jpg";

import kebab from "../../assets/kebab.jpg";
import littichoka from "../../assets/littichoka.jpg";
import paratha from "../../assets/paratha.jpg";

const streetFoods = [
  {
    name: "Pani Puri",
    image: panipuri,
    address: "Chowpatty Beach, Mumbai",
  },
  {
    name: "Vada Pav",
    image: vadapav,
    address: "Dadar Station, Mumbai",
  },
  {
    name: "Pav Bhaji",
    image: pavbhaji,
    address: "Juhu Beach, Mumbai",
  },
  {
    name: "Chole Bhature",
    image: chole,
    address: "Karol Bagh, Delhi",
  },
  {
    name: "Dabeli",
    image: dabeli,
    address: "Bhuj, Gujarat",
  },
  {
    name: "Aloo Tikki",
    image: alootikki,
    address: "Connaught Place, Delhi",
  },
  {
    name: "Kathi Roll",
    image: kathiroll,
    address: "Park Street, Kolkata",
  },
  {
    name: "Momos",
    image: momos,
    address: "Majnu Ka Tila, Delhi",
  },
  {
    name: "Samosa",
    image: samosa,
    address: "Chandni Chowk, Delhi",
  },
  {
    name: "Poha Jalebi",
    image: pohajalebi,
    address: "Indore, Madhya Pradesh",
  },
  {
    name: "Kachori",
    image: kachori,
    address: "Jaipur, Rajasthan",
  },
  {
    name: "Misal Pav",
    image: misalpav,
    address: "Pune, Maharashtra",
  },
  {
    name: "Sewaiyan",
    image: seviya,
    address: "Lucknow, Uttar Pradesh",
  },
  {
    name: "Bhel Puri",
    image: bhelpuri,
    address: "Marine Drive, Mumbai",
  },
  {
    name: "Dhokla",
    image: dhokla,
    address: "Ahmedabad, Gujarat",
  },
  {
    name: "Idli Sambar",
    image: idli,
    address: "T-Nagar, Chennai",
  },
  {
    name: "Medu Vada",
    image: meduvada,
    address: "Basavanagudi, Bangalore",
  },
  {
    name: "Kebabs",
    image: kebab,
    address: "Tunday Kababi, Lucknow",
  },
  {
    name: "Litti Chokha",
    image: littichoka,
    address: "Patna, Bihar",
  },
  {
    name: "Paratha",
    image: paratha,
    address: "Paranthe Wali Gali, Delhi",
  },
  
];



const StreetFoodList = () => {
  const [selectedName, setSelectedName] = useState("");

  const filteredFoods = selectedName
    ? streetFoods.filter((item) => item.name === selectedName)
    : streetFoods;

  // Get unique food names for the dropdown
  const foodNames = [...new Set(streetFoods.map((item) => item.name))];

  return (
    <div>
      <div style={styles.dropdownWrapper}>
        <label htmlFor="foodSelect" style={styles.label}>
          Filter by Food Name:{" "}
        </label>
        <select
          id="foodSelect"
          value={selectedName}
          onChange={(e) => setSelectedName(e.target.value)}
          style={styles.select}
        >
          <option value="">All Foods</option>
          {foodNames.map((name, index) => (
            <option key={index} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>

      <div style={styles.container}>
        {filteredFoods.map((item, idx) => (
          <div key={idx} style={styles.card}>
            <img src={item.image} alt={item.name} style={styles.image} />
            <h3 style={styles.name}>{item.name}</h3>
            <p style={styles.address}>{item.address}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  dropdownWrapper: {
    textAlign: "center",
    margin: "20px",
  },
  label: {
    fontSize: "16px",
    marginRight: "10px",
  },
  select: {
    padding: "8px 12px",
    fontSize: "16px",
    borderRadius: "5px",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "20px",
    padding: "20px",
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "10px",
    textAlign: "center",
    backgroundColor: "#fff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  },
  image: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  name: {
    margin: "10px 0 5px",
    fontSize: "1.1em",
  },
  address: {
    fontSize: "0.9em",
    color: "#666",
  },
};

export default StreetFoodList;
